module.exports = __webpack_public_path__ + "img/frame-advice-xl.bcdea9b5.png";